import { styled } from "@mui/material/styles";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import config from "../../../config";
import { Landvision } from "../icons";

const StyledLvText = styled("a")({
    textDecoration: "none",
    color: "white",
});

const Gallery = (props) => {
    const { images, propertyKey } = props;

    return (
        <div className="carousel-shell">
            <Carousel showIndicators={false}>
                {images.map((image) => {
                    return <img alt="" src={image} />;
                })}
            </Carousel>

            <div className="landvision">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${config.LANDVISION_URL}?resource=property&key=${propertyKey}`}
                >
                    <Landvision fill="#e0e0e0" />
                    <br />
                </a>
                <StyledLvText
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${config.LANDVISION_URL}?resource=property&key=${propertyKey}`}
                >
                    LandVision
                </StyledLvText>
            </div>
        </div>
    );
};

export default Gallery;
